export const FETCH_TAGS_LIST = 'FETCH_TAGS_LIST';
export const FETCH_TAGS_LIST_SUCCESS = 'FETCH_TAGS_LIST_SUCCESS';
export const FETCH_TAGS_LIST_FAILURE = 'FETCH_TAGS_LIST_FAILURE';
